export const T = {
  en_GB: {
    name: "Name",
    members: "Members",
    clients: "Clients",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    noTeamsYet: "No teams yet. Create a team to limit clients to a set of users.",
    noMembers: "No members",
    deleteTitle: "Delete team",
    deleteBody: (name: string, n: string) =>
      `Delete ${name}? ${n} clients limited to it lose this team.`,
    error: "Error",
    failedToDelete: "Failed to delete team",
    ok: "OK",
  },
  nb_NO: {
    name: "Navn",
    members: "Medlemmer",
    clients: "Kunder",
    actions: "Handlinger",
    edit: "Rediger",
    delete: "Slett",
    noTeamsYet: "Ingen team ennå. Opprett et team for å begrense kunder til noen brukere.",
    noMembers: "Ingen medlemmer",
    deleteTitle: "Slett team",
    deleteBody: (name: string, n: string) =>
      `Slette ${name}? ${n} kunder som er begrenset til det mister dette teamet.`,
    error: "Feil",
    failedToDelete: "Kunne ikke slette teamet",
    ok: "OK",
  },
} as const;
